import ENG from "./en.json";
import ESP from "./es.json";
import FRE from "./fr.json";
import config from "../utils/config";

export const defaultLocale = "ENG";

function applyBrand(messages) {
  const brand = config.brand.name;
  if (!brand || brand === "RPay") {
    return messages;
  }
  return JSON.parse(JSON.stringify(messages).replace(/RPay/g, brand));
}

export const languages = applyBrand({
  ENG,
  ESP,
  FRE,
});
